module.exports = __webpack_public_path__ + "static/img/jieshao1.02a4c344.png";